import ReactDOM from 'react-dom';

// third party
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import router from 'routes';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';
import { handleMsalPopupResponse } from 'views/auth/msalInstance';
import { isMsalPopupResponse } from 'views/auth/msalRedirect';

// style + assets
import 'assets/scss/style.scss';

// ==============================|| REACT DOM RENDER  ||============================== //

// The Microsoft sign-in popup returns to /login on this origin: hand its
// response to the opener and let the popup close instead of booting the app.
if (isMsalPopupResponse()) {
    handleMsalPopupResponse();
} else {
    ReactDOM.render(
        <Provider store={store}>
            <ConfigProvider>
                <RouterProvider router={router} />
            </ConfigProvider>
        </Provider>,
        document.getElementById('root')
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
